const calcNumberOfRequiredPieces = (
  unitLength: string = '',
  desiredLength: number | null | undefined
) => Math.round((desiredLength || 0) / parseFloat(unitLength));

export default calcNumberOfRequiredPieces;
